import { createEntityAdapter, createSlice } from '@reduxjs/toolkit'
import { StoreData } from '../reducers/typings'
import { IServiceFrequency } from './typings'
import { getServiceFrequencies } from './api'

export const serviceFrequencyAdapter = createEntityAdapter<IServiceFrequency>({
  sortComparer: (a, b) => a.annualOccurrences - b.annualOccurrences,
})

export const initialState = serviceFrequencyAdapter.getInitialState()

const serviceFrequencies = createSlice({
  name: 'serviceFrequencies',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getServiceFrequencies.fulfilled, (state, { payload }) => {
      serviceFrequencyAdapter.setAll(state, payload)
    })
  },
})

export default serviceFrequencies.reducer

export const selectors = serviceFrequencyAdapter.getSelectors<StoreData>(
  (state) => state.serviceFrequency,
)

export const { selectAll: selectAllServiceFrequencies } = selectors
